import "./App.css";
import MainLayout from "./components/MainLayout";
import MainLayoutKorisnik from "./components/MainLayoutKorisnik";
import MainLayoutAdmin from "./components/MainLayoutAdmin";
import Clanak from "./pages/Clanak/ClanakPage";
import EditClanak from "./pages/Clanak/EditClanak";
import AddNewAnketaPage from "./pages/Anketa/AddNewAnketaPage";
import DokumentsPageKorisnik from "./pages/Dokument/DokumentsPageKorisnik";
import DokumentsPage from "./pages/Dokument/DokumentsPage";
import StatistikaClanka from "./pages/Statistika/StatistikaClanakaPage";
import StatistikaDokumenata from "./pages/Statistika/StatistikaDokumenataPage";
import Anketa from "./pages/Anketa/AnketaPage";
import StatistikaAnketePage from "./pages/Statistika/StatistikaAnketePage";
import ViewClanak from "./pages/Clanak/ViewClanak";
import AddNewClanak from "./pages/Clanak/AddNewClanak";
import ClanakPage from "./pages/Clanak/ClanakPage";
import EditAnketaPage from "./pages/Anketa/EditAnketaPage";
import ViewAnketaTabs from "./pages/Anketa/ViewAnketaTabs";
import KorisnikHomePage from "./pages/Home/KorisnikHomePage";
import AnketaKorisnik from "./pages/Anketa/AnketaPageKorisnik";
import HomePage from "./pages/Home/HomePage";
import LoginForm from "./pages/LoginPage/components/LoginForm";
import { ConfigProvider } from "antd";
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import ViewAnketaPageKorisnik from "./pages/Anketa/ViewAnketaPageKorisnik";
import ClanakPageKorisnik from "./pages/Clanak/ClanakPageKorisnik";
import KorisnickiNalozi from "./pages/Nalozi/KorisnickiNaloziPage";
import AdminHomePage from "./pages/Home/AdminHomePage";
import { useAuth } from "./components/AuthContext";
import GalerijaPage from "./pages/Galerija/GalerijaPage";
import GalerijaPageKorisnik from "./pages/Galerija/GalerijaPageKorisnik";
import NotFoundPage from "./components/NotFound";

function App() {
  const { isLoggedIn, role, isLoading } = useAuth();

  if (isLoading) {
    return <div>Učitavanje...</div>;
  }
  return (
    <ConfigProvider
      theme={{
        token: {
          colorPrimary: "#39ad90",
          colorBgBase: "#fff",
          colorBgLayout: "#82cfbb",
          colorBgContainer: "#ffffff",
          colorTextBase: "#2b494b",
          colorText: "#2b494b",
          colorTextHeading: "#2b494b",
        },
      }}
    >
      <Router>
        <Routes>
          {isLoggedIn && role?.includes("ROLE_ZAPOSLENI") && (
            <Route path="/zaposleni/*" element={<MainLayout />}>
              <Route path="clanci" element={<Clanak />} />
              <Route path="galerija" element={<GalerijaPage />} />
              <Route path="clanci/:id" element={<ViewClanak />} />
              <Route
                path="kategorijaDokumenta/:kategorijaDokumentaId"
                element={<DokumentsPage />}
              />
              <Route path="ankete/sve" element={<Anketa />} />
              <Route path="dodaj-anketu" element={<AddNewAnketaPage />} />
              <Route path="dodaj-clanak" element={<AddNewClanak />} />
              <Route
                path="kategorijaClanka/:kategorijaClankaId"
                element={<ClanakPage />}
              />
              <Route path="anketa/:id" element={<ViewAnketaTabs />} />
              <Route path="anketa/:id/edit" element={<EditAnketaPage />} />
              <Route path="statistika/clanka" element={<StatistikaClanka />} />
              <Route path="clanci/:id/edit" element={<EditClanak />} />
              <Route
                path="statistika/dokumenata"
                element={<StatistikaDokumenata />}
              />
              <Route
                path="anketa/:anketaId/statistika"
                element={<StatistikaAnketePage />}
              />
              <Route path="home" element={<HomePage />} />
              <Route path="*" element={<NotFoundPage />} />
            </Route>
          )}

          {isLoggedIn && role?.includes("ROLE_ADMIN") && (
            <Route path="/admin/*" element={<MainLayoutAdmin />}>
              <Route path="home" element={<AdminHomePage />} />
              <Route path="korisnickiNalozi" element={<KorisnickiNalozi />} />
              <Route path="*" element={<NotFoundPage />} />
            </Route>
          )}

         {!isLoggedIn && (
            <>
              <Route
                path="/admin/*"
                element={<Navigate to="/home" replace />}
              />
              <Route
                path="/zaposleni/*"
                element={<Navigate to="/home" replace />}
              />
            </>
          )}

          <Route path="/*" element={<MainLayoutKorisnik />}>
            <Route index element={<KorisnikHomePage />} />
            <Route path="clanci" element={<Clanak />} />
            <Route path="home" element={<KorisnikHomePage />} />
            <Route path="clanci/:id" element={<ViewClanak />} />
            <Route
              path="sviDokumenti/:kategorijaDokumentaId"
              element={<DokumentsPageKorisnik />}
            />
            <Route path="ankete/sve" element={<AnketaKorisnik />} />
            <Route path="ankete/:id" element={<ViewAnketaPageKorisnik />} />
            <Route path="galerija" element={<GalerijaPageKorisnik />} />
            <Route
              path="sviClanci/:kategorijaClankaId"
              element={<ClanakPageKorisnik />}
            />
            <Route path="*" element={<NotFoundPage />} />
          </Route>

          <Route path="/login" element={<LoginForm />} />
          <Route path="*" element={<NotFoundPage />} />
        </Routes>
      </Router>
    </ConfigProvider>
  );
}

export default App;
